import React from "react";
import { UserDetailsPage, USER_TYPES } from "../../modules/user-management";

const SystemUserDetails = () => (
  <UserDetailsPage userType={USER_TYPES.SYSTEM} />
);

export default SystemUserDetails;
